import icons from 'url:../../img/icons.svg';

class PaginationView {
  #parentEl = document.querySelector('.pagination');
  #data;

  render(data) {
    this.#data = data;
    const markup = this.#generateMarkup();
    this.#clear();
    this.#parentEl.insertAdjacentHTML('afterbegin', markup);
  }
  #clear() {
    this.#parentEl.innerHTML = '';
  }

  addHandler(handler) {
    this.#parentEl.addEventListener('click', function (e) {
      const btn = e.target.closest('.btn--inline');
      if (!btn) return;
      // console.log(btn);
      const goto = +btn.dataset.goto;
      // console.log(goto);
      handler(goto);
    });
  }

  #generateMarkup() {
    const currPage = this.#data.page;
    const numOfPages = Math.ceil(
      this.#data.results.length / this.#data.resultperpage
    );
    if (currPage == 1 && numOfPages > 1) {
      return `
          <button data-goto=${
            currPage + 1
          } class="btn--inline pagination__btn--next">
            <span>Page ${currPage + 1}</span>
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-right"></use>
            </svg>
          </button>
      `;
    }
    if (currPage == numOfPages && numOfPages > 1) {
      return `
          <button data-goto=${
            currPage - 1
          } class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-left"></use>
            </svg>
            <span>Page ${currPage - 1}</span>
          </button>
      `;
    }
    if (currPage < numOfPages) {
      return `
          <button data-goto=${
            currPage - 1
          } class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-left"></use>
            </svg>
            <span>Page ${currPage - 1}</span>
          </button>
          <button data-goto=${
            currPage + 1
          } class="btn--inline pagination__btn--next">
            <span>Page ${currPage + 1}</span>
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-right"></use>
            </svg>
          </button>
      `;
    }
    return '';
  }
}

export default new PaginationView();
